import { Link, useLocation } from 'react-router-dom';
import { Facebook } from 'react-spinners-css';
import { ListGroup, ListGroupItem } from 'reactstrap';

const AdminList = ({ items = [], link = '', loading }) => {
    const loc = useLocation();
    return (
        <ListGroup style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
            {loading ? (
                <div className="mx-auto">
                    <Facebook color="eee" />
                </div>
            ) : (
                <>
                    {items.map((i) => (
                        <Link
                            key={i.id}
                            to={'/admin/' + link + '/' + i.id}
                            style={{ textDecoration: 'none' }}
                        >
                            <ListGroupItem
                                action
                                active={loc.pathname.includes(i.id)}
                            >
                                {i.name}
                            </ListGroupItem>
                        </Link>
                    ))}
                </>
            )}
        </ListGroup>
    );
};

export default AdminList;
